/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Exercise_Personal_Goal_ByInputs */

const en_us2_exercise_personal_goal_by = /** @type {(inputs: Exercise_Personal_Goal_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`by ${i?.date}`)
};

const pt_br2_exercise_personal_goal_by = /** @type {(inputs: Exercise_Personal_Goal_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`até ${i?.date}`)
};

const es_419_exercise_personal_goal_by = /** @type {(inputs: Exercise_Personal_Goal_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`para el ${i?.date}`)
};

const pt_pt2_exercise_personal_goal_by = /** @type {(inputs: Exercise_Personal_Goal_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`até ${i?.date}`)
};

const fr_fr2_exercise_personal_goal_by = /** @type {(inputs: Exercise_Personal_Goal_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`d'ici le ${i?.date}`)
};

const de_de2_exercise_personal_goal_by = /** @type {(inputs: Exercise_Personal_Goal_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`bis ${i?.date}`)
};

const it_it2_exercise_personal_goal_by = /** @type {(inputs: Exercise_Personal_Goal_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`entro il ${i?.date}`)
};

/**
* | output |
* | --- |
* | "by {date}" |
*
* @param {Exercise_Personal_Goal_ByInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_by = /** @type {((inputs: Exercise_Personal_Goal_ByInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_ByInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_by(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_by(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_by(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_by(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_by(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_by(inputs)
	return en_us2_exercise_personal_goal_by(inputs)
});
export { exercise_personal_goal_by as "exercise-personal.goal_by" }